import { createFileRoute } from "@tanstack/react-router";

import SettingsPage from "@/pages/settings/SettingsPage";

export const Route = createFileRoute("/_secure/settings/general")({
  component: RouteComponent,
});

function RouteComponent() {
  return <SettingsPage route="/settings/general" />;
}
